export { default } from '@/features/settings/pages/NotificationPage'
